export function translatePreferredDomainHidden(status: boolean): string {
    switch (status) {
        case true:
            return 'Hidden';
        case false:
            return 'Activated';
        default:
            return 'Not Defined';
    }
}
